
import { DocumentReportIcon } from '@vue-hero-icons/outline';

export default {
  components: { DocumentReportIcon },
};
